/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cart': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17 18c-1.11 0-2 .89-2 2 0 1.1.9 2 2 2s2-.9 2-2a2 2 0 0 0-2-2M1 2v2h2l3.6 7.59-1.36 2.45A2.006 2.006 0 0 0 7 17h12v-2H7.42c-.14 0-.25-.11-.25-.25 0-.05.01-.09.03-.12L8.1 13h7.45c.75 0 1.41-.42 1.75-1.03l3.58-6.47c.07-.16.12-.33.12-.5 0-.55-.45-1-1-1H5.21l-.94-2M7 18c-1.11 0-2 .89-2 2 0 1.1.9 2 2 2s2-.9 2-2a2 2 0 0 0-2-2z"/>'
  }
})
